const isTouchDevice = () => {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
};

if (!customElements.get('custom-accordion')) {
  customElements.define(
    'custom-accordion',
    class CustomAccordion extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.items = this.querySelectorAll('.custom-accordion-item');

        const video = this.querySelector('video');
        if (video) {
          if (!isTouchDevice()) {
            video.controls = false;

            video.addEventListener('mouseenter', () => {
              video.controls = true;
            });

            video.addEventListener('mouseleave', () => {
              video.controls = false;
            });
          } else {
            video.controls = true;
          }
        }

        this.items.forEach(item => {
          const button = item.querySelector('.custom-accordion-title');
          const content = item.querySelector('.custom-accordion-content');

          button.addEventListener('click', () => {
            const isOpen = button.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
              content.style.maxHeight = null;
              content.setAttribute('aria-hidden', 'true');
              button.setAttribute('aria-expanded', 'false');
              item.classList.remove('open');
            } else {
              this.items.forEach(openItem => {
                if (openItem !== item) {
                  const openButton = openItem.querySelector('.custom-accordion-title');
                  const openContent = openItem.querySelector('.custom-accordion-content');
                  openContent.style.maxHeight = null;
                  openContent.setAttribute('aria-hidden', 'true');
                  openButton.setAttribute('aria-expanded', 'false');
                  openItem.classList.remove('open');
                }
              });

              content.style.maxHeight = content.scrollHeight + 'px';
              content.setAttribute('aria-hidden', 'false');
              button.setAttribute('aria-expanded', 'true');
              item.classList.add('open');
            }
          });
        });
      }
    }
  );
}
